import { type ProcedimentoConTask } from '@framework/api-client/api/backoffice/schemas/procedimentoConTask.ts';
import { GetFrontTipiDomandaTipoPresentazione } from '@framework/api-client/api/inquiries-compile/schemas/getFrontTipiDomandaTipoPresentazione.ts';
import { useGetFrontTipiDomanda } from '@framework/api-client/api/inquiries-compile/tipi-domanda/tipi-domanda.ts';
import { useMemo } from 'react';
import { getStartableInquiries } from '../utils/getStartableInquiries.ts';

/**
 * Domande secondarie avviabili ad oggi dalla pratica, con le relative
 * date di avvio.
 */
export function useStartableInquiries(dossierProcedure: ProcedimentoConTask) {
  const startableData = dossierProcedure.pratica?.domandeAvviabili;

  const groupIds = useMemo(
    () =>
      (startableData
        ?.map(inquiry => inquiry.idGruppoTipoDomanda)
        .filter(Boolean) as string[]) ?? [],
    [startableData],
  );

  const { data, isLoading, error } = useGetFrontTipiDomanda(
    {
      idsGruppi: groupIds,
      tipoPresentazione: GetFrontTipiDomandaTipoPresentazione.SECONDARIA,
    },
    {
      query: {
        keepPreviousData: true,
        enabled: groupIds.length > 0,
      },
    },
  );

  const inquiries = useMemo(
    () => getStartableInquiries(data?.dati ?? [], startableData),
    [data?.dati, startableData],
  );

  return { inquiries, isLoading, error };
}
